import { FC, useEffect, useRef, useState } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import { queryStageCompleteness } from '../../../apis';
import styled from './index.module.scss';
import IconArr from './IconArr';
import IconArr2 from './IconArr2';
import WinTable from './WinTable';
import WinShare from './WinShare';
import WinPolicy from './WinPolicy';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';
import { getCurrentPlan } from '@/service/referral';
import { useMembersStore } from '@/components/MembersDay/MembersProvider';
import { message } from '@/components/UI/Message';
import gtm from '@/utils/gtm';

import { IPageStatus } from '@/components/MembersDay/type';
interface IProps {
    type?: string;
}

const Banner: FC<IProps> = ({}) => {
    const { t: tt } = useLang('membersday.teaser.ReferralNext');
    const { t: ta } = useLang('membersday.activity.ReferralNext');
    const [openDescA, setopenDescA] = useState(false);
    const [winType, setWinType] = useState('');
    const [styleWidth, setStyleWidth] = useState({ width: '0%' });
    const [style100, setStyle100] = useState({ width: '100%' });
    const [percentageA, setPercentageA] = useState(0); //进度
    const [planData, setPlanData] = useState<any>({ planId: null });
    const { locale, pathname } = getLocal();
    const { pageStatus } = useMembersStore();

    // jp站点 teaser、activity同一个组件不同文案
    const t = (() => {
        if (locale === 'jp' && pageStatus === IPageStatus.ACTIVITY) {
            return ta;
        }
        return tt;
    })();

    const stageLocalMap = {
        us: {
            stage1: 500,
            stage2: 1000,
            stage3: 1500,
        },
        ca: {
            stage1: 100,
            stage2: 250,
            stage3: 500,
        },
        au: {
            stage1: 100,
            stage2: 500,
            stage3: 1000,
        },
        za: {
            stage1: 500,
            stage2: 1000,
            stage3: 2000,
        },
        kr: {
            stage1: 100,
            stage2: 200,
            stage3: 300,
        },
        uk: {
            stage1: 40,
            stage2: 80,
            stage3: 120,
        },
        eu: {
            stage1: 50,
            stage2: 100,
            stage3: 150,
        },
        de: {
            stage1: 100,
            stage2: 150,
            stage3: 200,
        },
        fr: {
            stage1: 100,
            stage2: 150,
            stage3: 200,
        },
        it: {
            stage1: 100,
            stage2: 150,
            stage3: 200,
        },
        es: {
            stage1: 40,
            stage2: 80,
            stage3: 120,
        },
    };
    const toggleDescAHandle = () => {
        const openDescA2 = openDescA;
        setopenDescA(!openDescA2);
    };
    const winHandle = (type: string) => {
        setWinType(type);
    };
    const closeHandle = () => {
        setWinType('');
    };
    const initFn = async () => {
        const res1: any = await queryStageCompleteness(locale, '2');
        const stageMap = stageLocalMap[locale];

        if (res1.code === '0' && stageMap) {
            const data = res1.data || {};
            const completeNumberDecimal1 = res1.data?.completeNumberDecimal || 0;
            // const completeNumberDecimal1 = 121 || 0;
            // const completeNumberDecimal2 = Math.min(completeNumberDecimal1, 100); //百分比超过100,取100
            // console.log('data', data);
            const curStage =
                completeNumberDecimal1 >= stageMap.stage3
                    ? 4
                    : completeNumberDecimal1 >= stageMap.stage2
                    ? 3
                    : completeNumberDecimal1 >= stageMap.stage1
                    ? 2
                    : 1;
            setPercentageA(curStage);
            let val = 0;
            if (curStage === 4) {
                val = completeNumberDecimal1 !== stageMap.stage3 ? 75 : 0;
            } else if (curStage === 3) {
                val = ((completeNumberDecimal1 - stageMap.stage2) * 100) / (stageMap.stage3 - stageMap.stage2);
            } else if (curStage === 2) {
                val = ((completeNumberDecimal1 - stageMap.stage1) * 100) / (stageMap.stage2 - stageMap.stage1);
            } else if (curStage === 1) {
                val = (completeNumberDecimal1 * 100) / stageMap.stage1;
            }
            val += '%';
            // setPercentageA(4);
            // const val = `${completeNumberDecimal2}%`;

            setStyleWidth(window?.innerWidth > 1024 ? { width: val } : { height: val });
            setStyle100(window?.innerWidth > 1024 ? { width: '100%' } : { height: '100%' });
        }
    };

    const initialPlan = async () => {
        const plan = await getCurrentPlan(locale, `/${locale}/referral`);

        if (plan.code !== '0') return message.error(plan.message);
        if (!plan.data || !plan.data.planId) return;
        setPlanData(plan.data);
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            initFn();
            initialPlan();
        }
    }, []);

    const [isEnterA, setisEnterA] = useState(false);
    const isEnterRefA = useRef(false);

    useEffect(() => {
        const elem = document.querySelector(`#teaser-ReferralNext`);
        if (elem) {
            window.addEventListener('scroll', () => {
                const clientH = document.documentElement.clientHeight;
                const enterAH = clientH - 150;
                const { top } = elem.getBoundingClientRect();
                const hIsEnterA = top < enterAH; //距离已进入
                if (!isEnterRefA.current && hIsEnterA) {
                    isEnterRefA.current = true;
                    setisEnterA(true);
                } else if (isEnterRefA.current && !hIsEnterA) {
                    isEnterRefA.current = false;
                    setisEnterA(false);
                }
            });
        }
    }, []);

    return (
        <div className={`${styled.Banner} teaser-ReferralNext`} id="teaser-ReferralNext">
            <div className={`members-day-inter editor-ani-trigger${isEnterA ? ' isEnter' : ''}`}>
                <div className="members-day-title members-day-text-left editor-ani-title-1">{t('title')}</div>
                <div className="members-day-sub-title members-day-text-left editor-ani-title-2">
                    <div>{t('subTitle1')}</div>
                    {t.rich('subTitle2', {
                        color2: (text: string) => <span className="box-color2">{text}</span>,
                    })}
                </div>
                <div className="img-box-a">
                    <EditorImg
                        pc="https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711006192880/referringjpg.jpg"
                        h5="https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711006233915/referringjpg.jpg"
                    />
                    <div className="img-box-msg">
                        <div className="members-day-text-width">
                            <p className="img-box-desc">{t('btnDesc2')}</p>
                            <button
                                className="img-box-btn"
                                onClick={() => {
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'ecocredits_button',
                                        type: 'Referral',
                                        list_name: t('title'),
                                        button_name: t('btnText'),
                                    });
                                    winHandle('WinShare');
                                }}
                            >
                                {t('btnText')}
                            </button>
                            <button
                                className="img-box-btn-text"
                                onClick={() => {
                                    winHandle('WinPolicy');
                                }}
                            >
                                {t('linkBtn1')}
                                <IconArr2 />
                            </button>
                            <button
                                className="img-box-btn-text"
                                onClick={() => {
                                    winHandle('WinTable');
                                }}
                            >
                                {t('linkBtn2')}
                                <IconArr2 />
                            </button>
                        </div>
                    </div>
                </div>
                <div className={`msg-box-b${openDescA ? ' msg-box-b-desc-open' : ''}`}>
                    <div className="members-day-text-width">
                        <div className="msg-box-desc">
                            <span className="msg-box-desc-1">
                                {t.rich('processDescB1', {
                                    text: (text: string) => <span className="color-white">{text}</span>,
                                })}
                            </span>
                            <span className="msg-box-desc-2">
                                {t.rich('processDescB2', {
                                    num1: (text: string) => <span>xxx</span>,
                                    num2: (text: string) => <span>xxx</span>,
                                    num3: (text: string) => <span>xxx</span>,
                                    text: (text: string) => <span className="color-white">{text}</span>,
                                })}
                                {/* {t('processDescB2')} */}
                            </span>
                            <span className="msg-box-b-icon" onClick={toggleDescAHandle}>
                                <IconArr />
                            </span>
                        </div>
                        {locale !== 'jp' && (
                            <div className="progress-wrapper">
                                <div className="progress-box">
                                    <div className="progress-regular">
                                        {[1, 2, 3].map((i: any) => (
                                            <div
                                                className={`progress-item progress-item-${i} ${percentageA === i && i !== 1 ? 'bling' : ''} ${
                                                    percentageA >= i ? 'item-active' : ''
                                                }`}
                                                key={i}
                                            >
                                                <p className="line" style={percentageA > i ? style100 : percentageA === i ? styleWidth : {}}></p>
                                                <div className="circle">
                                                    <div className="base"></div>
                                                    <div className="c1"></div>
                                                    <div className="c2"></div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className={`progress-end ${percentageA === 4 ? 'bling' : ''} ${percentageA >= 4 ? 'item-active' : ''}`}>
                                        <p className="line" style={percentageA > 4 ? style100 : percentageA === 4 ? styleWidth : {}}></p>
                                        <div className="circle">
                                            <div className="base"></div>
                                            <div className="c1"></div>
                                            <div className="c2"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="progress-text">
                                    <div className="text-arr">
                                        {[1, 2, 3]?.map((i: any) => (
                                            <p className={`text-list text-list-${i} ${percentageA >= i ? 'active-text' : ''}`} key={i}>
                                                {t(i === 1 ? 'processItemInit' : i === 2 ? 'processItemA' : 'processItemB')}
                                            </p>
                                        ))}
                                    </div>
                                    <p className={`last-text ${percentageA >= 4 ? 'active-text' : ''}`}>{t('processItemC')}</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {winType === 'WinTable' && <WinTable planId={planData?.planId} callback={closeHandle} />}
            {winType === 'WinShare' && <WinShare planData={planData} callback={closeHandle} />}
            {winType === 'WinPolicy' && <WinPolicy callback={closeHandle} planData={planData} />}
        </div>
    );
};

export default Banner;
